import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { textTruncateByLength } from 'utils/other';
import { connect } from 'react-redux';
import { logout } from 'redux/modules/auth/action';
import { withRouter } from 'react-router';
// import ReactTooltip from 'react-tooltip';

const DesktopMenu = ({ auth, logout, history }) => {
    const [selectedNavItem, setSelectedNavItem] = useState('');
    const [isAccountOpen, setIsAccountOpen] = useState(false);

    useEffect(() => {
        setSelectedNavItem(history.location.pathname);
        
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [history, history.location.pathname]);

    const refreshPage = () => {
        if(history.location.pathname.includes('/add-entity/')) {
            history.push('/add-entitiy')
            window.location.reload();
        } else if(history.location.pathname === '/add-entity') {
            window.location.reload();
        }
    }

    return (
        <div className="userMenuDesktop">
            <div className="sidebar_first-container" style={{ marginTop: '15px' }}>
                {auth.permissions && auth.permissions.includes('entity') &&
                    <Link className="nav_bar-item" to="/home" style={selectedNavItem === '/home' ? { backgroundColor: '#FF8700' } : {}}>
                        <i className="fas fa-home" />
                        <span>Home</span>
                    </Link>
                }
                {auth.permissions && auth.permissions.includes('search') &&
                <Link className="nav_bar-item" to="/saved-searches"
                      style={selectedNavItem === '/saved-searches' ? {backgroundColor: '#FF8700'} : {}}>
                    <i className="fas fa-search"/>
                    <span>Searches</span>
                </Link>
                }
                {/*!auth.isSingleUser &&
                    <Link className="nav_bar-item" to="/users" style={selectedNavItem === '/users' ? { backgroundColor: '#FF8700' } : {}}>
                        <i className="fas fa-users" />
                        <span>Users</span>
                    </Link>
                */}
                {auth.permissions && auth.permissions.includes('fetches') &&
                <Link className="nav_bar-item" to="/feeds/fetches"
                      style={selectedNavItem === '/feeds/fetches' ? {backgroundColor: '#FF8700'} : {}}>
                    <i className="fas fa-bars"/>
                    <span>Fetches</span>
                </Link>
                }
                {auth.permissions && auth.permissions.includes('reader') &&
                <Link className="nav_bar-item" to="/ticker"
                      style={selectedNavItem === '/ticker' ? {backgroundColor: '#FF8700'} : {}}>
                    <i className="fas fa-book-open"/>
                    <span>Ticker</span>
                </Link>
                }
                {/* <Link className="nav_bar-item" to="/settings" style={selectedNavItem === '/settings' ? { backgroundColor: '#FF8700' } : {}}>
                    <i className="fas fa-cog" />
                    <span>Settings</span>
                </Link> */}
            </div>
            {auth.permissions && auth.permissions.includes('entity') &&
                <div className="sidebar_first-container">
                    <Link
                        className="nav_bar-item_circle"
                        to="/add-entity"
                        style={{ marginBottom: '15px' }}
                        onClick={refreshPage}
                        id="add-entity-btn"
                        // data-tip="Create entity"
                    >
                        <i className="fas fa-plus"/>
                    </Link>
                    {/*<ReactTooltip*/}
                    {/*    place="bottom"*/}
                    {/*    // effect="solid"*/}
                    {/*    delayShow={400}*/}
                    {/*    className="tooltip-thin"*/}
                    {/*/>*/}
                    {/*<Link className="nav_bar-item_circle" to="/search">*/}
                    {/*    <i className="fas fa-search" />*/}
                    {/*</Link>*/}
                </div>
            }
            <div className="sidebar_first-container" style={{ marginBottom: '15px' }}>
                <div className="nav_bar-account" onClick={() => setIsAccountOpen(!isAccountOpen)}>
                    <div className="nav_bar-item">
                        <i className="fas fa-user-circle" />
                        <span>Account</span>
                    </div>
                    {//isAccountOpen &&
                        <div className="account-panel-container">
                            {/* <div className="account-arrow-container">
                                <div className="account-arrow"></div>
                            </div> */}
                            <div className="account-main-container">
                                <div style={{ padding: '10px 20px', borderBottom: '1px solid #c8ced3', fontSize: '16px' }}>
                                    {auth.accountName &&
                                        <div style={{ fontWeight: '700' }}>
                                            {!auth.isSingleUser ? 'Organization: ' + textTruncateByLength(auth.accountName, 20) : textTruncateByLength(auth.accountName, 30)}
                                        </div>
                                    }
                                    <div style={{ color: '#768192' }}>
                                        {textTruncateByLength(auth.username, 30)}
                                    </div>
                                </div>
                                <div style={{ borderBottom: '1px solid #c8ced3' }}>
                                    <Link 
                                        className="account-button" 
                                        to="/settings" 
                                        style={selectedNavItem === '/settings' ? { backgroundColor: '#FF8700', color: 'white' } : {}}
                                    >
                                        <i className="fas fa-cog" />
                                        <span>Settings</span>
                                    </Link>
                                    {!auth.isSingleUser &&
                                        <Link 
                                            className="account-button" 
                                            to="/users" 
                                            style={selectedNavItem === '/users' ? { backgroundColor: '#FF8700', color: 'white' } : {}}
                                        >
                                            <i className="fas fa-users" />
                                            <span>Users</span>
                                        </Link>
                                    }
                                    <Link 
                                        className="account-button" 
                                        to="/terms-of-service"
                                        style={selectedNavItem === '/terms-of-service' ? { backgroundColor: '#FF8700', color: 'white' } : {}}
                                    >
                                        <i className="fas fa-file-alt" />
                                        <span>Terms of Service</span>
                                    </Link>
                                    <Link 
                                        className="account-button" 
                                        to="/privacy-policy"
                                        style={selectedNavItem === '/privacy-policy' ? { backgroundColor: '#FF8700', color: 'white' } : {}}
                                    >
                                        <i className="fas fa-user-shield" />
                                        <span>Privacy Policy</span>
                                    </Link>
                                </div>
                                <div className="account-button" onClick={logout} style={{ zIndex: '10' }}>
                                    <i className="fas fa-sign-out-alt" />
                                    <span>Logout</span>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                {/* <Link className="nav_bar-item" to="/" onClick={logout}>
                    <i className="fas fa-sign-out-alt" />
                    <span>Logout</span>
                </Link> */}
            </div>
        </div>
    );
};

const mapStateFromProps = (state) => ({
    auth: state.auth,
});

export default connect(
    mapStateFromProps,
    { logout }
)(withRouter(DesktopMenu));
